import { useEffect, useState, useRef } from 'react';

/**
 * useRenderMode provides a convenient hook that can be used to force an update
 * on a component when the app is hydrated on the client side.
 */
export const useRenderMode = () => {
  const mode = useRef('ssr');
  const [, setMode] = useState(false);
  useEffect(() => {
    // react-testing library doesn't like state updates from a mounting component
    if (typeof jest === 'undefined') {
      mode.current = 'csr';
      setMode(true);
    }
    return () => {
      mode.current = 'ssr';
    };
  }, []);
  return mode.current;
};
